import React from 'react';
import { View, Text, FlatList, StyleSheet } from 'react-native';
import { clientesMock } from '../../data/clientesMock';

const ScoreCircle = ({ score }) => {
  let color = '#FF4136'; // Vermelho para score baixo

  if (score >= 80) {
    color = '#2ECC40'; // Verde para score alto
  } else if (score >= 50) {
    color = '#FF851B'; // Laranja para score médio
  }

  return (
    <View style={[styles.scoreCircle, { backgroundColor: color }]}>
      <Text style={styles.scoreText}>{score}%</Text>
    </View>
  );
};

const TopClientesCard = () => {
  const topClientes = clientesMock
    .sort((a, b) => b.pontualidade - a.pontualidade)
    .slice(0, 5);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Melhores Clientes</Text>
      <FlatList
        data={topClientes}
        renderItem={({ item }) => (
          <View style={styles.itemContainer}>
            <View style={styles.clienteRow}>
              <View style={styles.clienteInfo}>
                <Text style={styles.razao}>{item.razao}</Text>
                <Text>Pontualidade: {item.pontualidade}%</Text>
              </View>
              <ScoreCircle score={item.pontualidade} />
            </View>
          </View>
        )}
        keyExtractor={item => item.id.toString()}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    margin: 10,
    borderRadius: 10,
    padding: 15
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10
  },
  itemContainer: {
    marginBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#eee'
  },
  clienteRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  clienteInfo: {
    flex: 1,
    marginRight: 10
  },
  razao: {
    fontWeight: 'bold'
  },
  scoreCircle: {
    width: 60,
    height: 60,
    borderRadius: 30,
    justifyContent: 'center',
    alignItems: 'center'
  },
  scoreText: {
    color: 'white',
    fontWeight: 'bold'
  }
});

export default TopClientesCard;
